export const TEASER_COLLAGE_IMAGES = [
  'https://media-api.xogrp.com/images/74920e73-57ec-4e66-a198-c97f0c7cb7c3', // dinnerware
  'https://media-api.xogrp.com/images/3a3525a8-5ad3-4c23-9e8d-574e2104e996', // glassware
  'https://media-api.xogrp.com/images/334078af-74aa-4451-844d-c1854ffc7a0d', // packing cubes
];

// How many products of a recommendation group the main side-rail pane
// previews; the See-more pane starts after this prefix.
export const GIFT_ADVISOR_GROUP_PREVIEW_COUNT = 8;

// Registry Interaction properties for the PDA-2007 refresh triggers.
export const GIFT_ADVISOR_REFRESH_SELECTION = 'refresh recommendations';
export const GIFT_ADVISOR_REFRESH_HEADER_DECISION_AREA =
  'gift-advisor-v2-recs-header';
export const GIFT_ADVISOR_REFRESH_FOOTER_DECISION_AREA =
  'gift-advisor-v2-recs-footer';

// Registry Interaction / eComm properties for gift advisor v2 recs rail.
export const GIFT_ADVISOR_RECS_DECISION_AREA = 'gift-advisor-v2-recs';
export const GIFT_ADVISOR_MORE_SUGGESTIONS_SELECTION = 'More suggestions';
export const GIFT_ADVISOR_BRAND_SELECTION = 'brand';
export const GIFT_ADVISOR_INTEREST_SELECTION = 'interest';
export const GIFT_ADVISOR_SUBCATEGORY_SELECTION = 'subcategory';
export const GIFT_ADVISOR_VIEW_BRANDS_SELECTION = 'view brands';
export const GIFT_ADVISOR_VIEW_INTERESTS_SELECTION = 'view interests';
export const GIFT_ADVISOR_VIEW_CATEGORIES_SELECTION = 'view categories';
export const GIFT_ADVISOR_BRANDS_IMPRESSION_ID = 'gift-advisor-v2-brands';
export const GIFT_ADVISOR_INTERESTS_IMPRESSION_ID = 'gift-advisor-v2-interests';
export const GIFT_ADVISOR_CATEGORIES_IMPRESSION_ID =
  'gift-advisor-v2-categories';
